import './App.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; 
import Home from './Home/Home';
import CategoryPage from './Category/CategoryPage';
import CategoryDetails from './CategoryDetails/CategoryDetails';
function App() {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
    <Routes>
      <Route path="/category" element={<CategoryPage />} />
    </Routes>
    <Routes>
      <Route path="/category-details" element={<CategoryDetails />} />
    </Routes>
  </Router>
  );
}

export default App;
